import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/home/home.component').then((c) => c.HomeComponent),
  },
  {
    path: 'station/:code',
    loadComponent: () =>
      import('./pages/station-detail/station-detail.component').then(
        (c) => c.StationDetailComponent,
      ),
  },
  {
    path: 'warnings',
    loadComponent: () =>
      import('./pages/warnings/warnings.component').then(
        (c) => c.WarningsComponent,
      ),
  },
  {
    path: 'bulletins',
    loadComponent: () =>
      import('./pages/bulletins/bulletins.component').then(
        (c) => c.BulletinsComponent,
      ),
  },
  {
    path: 'bulletins/:id',
    loadComponent: () =>
      import('./pages/bulletin-detail/bulletin-detail.component').then(
        (c) => c.BulletinDetailComponent,
      ),
  },
  {
    path: 'privacy',
    loadComponent: () =>
      import('./pages/privacy/privacy.component').then(
        (c) => c.PrivacyComponent,
      ),
  },
];
